export const environment = {
    local: false,
    stage: 'dev',
    production: false,
    localStorageSecretKey: 'sokrates_jaya_jaya_jaya',
    api: {
        url: 'api.sokrates.xyz',
        secure: true,
    },
    s3: {
        url: 'sokrates-multitenant-development-bucket.s3.ap-southeast-1.amazonaws.com',
        secure: true,
    },
    clientId: {
        google: '876703681895-hppnlll0b367bc1d47eaadc95okuoubd.apps.googleusercontent.com',
    },
};
